module.exports = __webpack_public_path__ + "static/flags/MK-e46dfbf09045b9f99fadb14e1a0f4b2c.gif";